"use client";
import React, { useState } from "react";
import Navbar from "../../navbar/Navbar";
import CartUi from "./Cart";
import { Box } from "@mui/material";
import { trackEvent, waitForBranch } from "@/app/utils/branch";
import { FooterNavigation } from "../../mobile-componenet/FooterNavigation";
import { cartPageBackgroundSx } from "./cartUi";

export const CartWraper = () => {
  const [reloadCartService, setReloadCartService] = useState(false);

  React.useEffect(() => {
    waitForBranch().then(() => {
      trackEvent("CART_VIEW", null);
    });
  }, []);

  return (
    <Box className="cart-page-main" sx={cartPageBackgroundSx}>
      <Box sx={{ display: { xs: "none", sm: "block" } }}>
        <Navbar
          setReloadCartService={() => setReloadCartService(true)}
          reloadScrollFlag={false}
          reloadSearchPositionFlag={false}
          reloadNavBackground={0.1}
          visible={true}
        />
      </Box>
      <CartUi
        reloadCartService={reloadCartService}
        setReloadCartService={() => setReloadCartService(false)}
      />
      <FooterNavigation />
    </Box>
  );
};
